import React from "react";
import { Link } from "react-router-dom";

import aboutHero from "../assets/About.png";
import team from "../assets/team.png";

const About = () => {
  return (
    <div className="text-white overflow-hidden">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[80vh] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${aboutHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>

        <div className="relative z-10 px-6 animate-fadeIn">
          <h1 className="text-4xl md:text-6xl font-bold">
            About <span className="text-purple-400">TheLogicWaves</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto text-lg">
            We are a team of innovators, creators, and developers building
            impactful digital solutions.
          </p>
        </div>
      </section>

     {/* ================= STORY (PREMIUM) ================= */}
<section className="py-24 px-6 bg-[#0b1a35]">
  <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">

    {/* TEXT */}
    <div className="animate-slideLeft">
      <h2 className="text-5xl font-bold mb-6 leading-tight">
        Our <span className="text-purple-400">Story</span>
      </h2>

      <p className="text-gray-300 mb-6 leading-relaxed text-lg">
        TheLogicWaves started with a simple vision — to transform ideas into
        meaningful digital experiences.
      </p>

      <p className="text-gray-400 leading-relaxed">
        Today, we craft powerful digital products that help businesses scale,
        innovate, and dominate their industries.
      </p>
    </div>

    {/* IMAGE WITH GLOW */}
    <div className="relative group">
      <div className="absolute -inset-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl blur opacity-40 group-hover:opacity-70 transition"></div>

      <img
        src={team}
        alt="Team"
        className="relative rounded-xl shadow-2xl hover:scale-105 transition duration-500"
      />
    </div>

  </div>
</section>
    {/* ================= MISSION / VISION ================= */}
<section className="py-24 px-6 bg-[#081225]">
  <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">

    {/* MISSION */}
    <div className="group p-10 rounded-2xl bg-gradient-to-br from-[#111c3a] to-[#0a192f] border border-white/10 hover:scale-105 transition">

      <h3 className="text-2xl font-bold mb-4 text-purple-400">
        🚀 Our Mission
      </h3>

      <p className="text-gray-300 leading-relaxed">
        To deliver cutting-edge software solutions & digital strategies that harness the power of emerging technologies, faster growth & provide sustainable value to our clients.
        We aim to build long-term partnerships through innovation, transparency & client-focused development.
      </p>
    </div>

    {/* VISION */}
    <div className="group p-10 rounded-2xl bg-gradient-to-br from-[#111c3a] to-[#0a192f] border border-white/10 hover:scale-105 transition">

      <h3 className="text-2xl font-bold mb-4 text-pink-400">
        🌍 Our Vision
      </h3>

      <p className="text-gray-300 leading-relaxed">
       To revolutionize the digital landscape by creating, innovative, data-driven solutions that empower businesses to thrive in an ever-evolving technological world.
      </p>
    </div>

  </div>
</section>

    {/* ================= WHY CHOOSE US ================= */}
<section className="py-24 px-6 bg-[#0b1a35] text-center">

  <h2 className="text-5xl font-bold mb-16">
    Why Choose <span className="text-purple-400">Us</span>
  </h2>

  <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">

    {[
      { title: "Creative Design", icon: "🎨" },
      { title: "Secure Development", icon: "🔒" },
      { title: "Client Focused", icon: "🤝" },
    ].map((item, i) => (
      <div
        key={i}
        className="group p-10 rounded-2xl bg-[#112240] border border-white/10 hover:-translate-y-2 transition duration-300"
      >
        <div className="text-4xl mb-4">{item.icon}</div>

        <h3 className="text-xl font-semibold mb-2 group-hover:text-purple-400">
          {item.title}
        </h3>

        <p className="text-gray-400 text-sm">
          We deliver excellence with innovation and precision.
        </p>
      </div>
    ))}

  </div>
</section>

   {/* ================= STATS ================= */}
<section className="py-24 px-6 bg-gradient-to-r from-purple-600 via-indigo-600 to-pink-600 text-center">

  <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-10">

    {[
      { num: "50+", label: "Projects Completed" },
      { num: "30+", label: "Happy Clients" },
      { num: "5+", label: "Years Experience" },
      { num: "100%", label: "Client Satisfaction" },
    ].map((stat, i) => (
      <div key={i} className="hover:scale-110 transition">
        <h3 className="text-4xl font-bold mb-2">{stat.num}</h3>
        <p className="text-sm opacity-90">{stat.label}</p>
      </div>
    ))}

  </div>
</section>
      {/* ================= CTA ================= */}
<section className="py-24 px-6 text-center bg-[#081225]">

  <h2 className="text-5xl font-bold mb-6">
    Let’s Build Something <span className="text-purple-400">Amazing</span>
  </h2>

  <p className="text-gray-300 mb-8 text-lg">
    Ready to grow your business with us?
  </p>

  <Link to="/contact">
    <button className="px-10 py-4 text-lg bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl hover:scale-105 shadow-lg transition">
      Get In Touch
    </button>
  </Link>

</section>

    </div>
  );
};

export default About;